
export enum PricingEnum {
  one = 'PREDICTA_ONE',
  infinity = 'PREDICTA_INFINITY',
  avusa = 'PREDICTA_CONSULTA_AVULSA',
};
